import { render, staticRenderFns } from "./PharmacistUpdate.vue?vue&type=template&id=9e97c18a&scoped=true&"
import script from "./PharmacistUpdate.vue?vue&type=script&lang=ts&"
export * from "./PharmacistUpdate.vue?vue&type=script&lang=ts&"
import style0 from "./PharmacistUpdate.vue?vue&type=style&index=0&id=9e97c18a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e97c18a",
  null
  
)

export default component.exports